import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import Profile from "../Pages/Profile/Profile";
import SchoolsListing from "../Pages/Admin/Schools/SchoolsListing/SchoolsListing";
import AddSchool from "../Pages/Admin/Schools/AddSchool/AddSchool";
import PendingApproval from "../Pages/Admin/PendingApproval/PendingApproval";
import RejectedApproval from "../Pages/Admin/RejectedApproval/RejectedApproval";
import ApprovedUsers from "../Pages/Admin/ApprovedUsers/ApprovedUsers";
import UserProfile from "../Pages/Admin/UserProfile/UserProfile";
import ClassesAndCourses from "../Pages/Admin/ClassesAndCourses/ClassesAndCourses";
import AddClass from "../Pages/Admin/ClassesAndCourses/AddClass/AddClass";
import CoursesListing from "../Pages/Admin/ClassesAndCourses/CoursesListing/CoursesListing";
import AddCourse from "../Pages/Admin/ClassesAndCourses/AddCourse/AddCourse";
import Attendance from "../Pages/Admin/Attendance/Attendance";
import AddAttendance from "../Pages/Admin/Attendance/AddAttendance/AddAttendance";
import PreviousAttendance from "../Pages/Admin/Attendance/PreviousAttendance/PreviousAttendance";
import ExamListing from "../Pages/Admin/ClassesAndCourses/Exams/ExamListing/ExamListing";
import AddExam from "../Pages/Admin/ClassesAndCourses/Exams/AddExam/AddExam";
import AddResult from "../Pages/Admin/Results/AddResult/AddResult";
import ExamResult from "../Pages/Admin/Results/ExamResult/ExamResult";
import Expenses from "../Pages/Admin/Expenses/Expenses";
import Income from "../Pages/Admin/Income/Income";
import AddIncome from "../Pages/Admin/Income/AddIncome/AddIncome";
import AddExpenses from "../Pages/Admin/Expenses/AddExpenses/AddExpenses";
import SportsListing from "../Pages/Admin/Sports/SportsListing/SportsListing";
import AddSport from "../Pages/Admin/Sports/AddSport/AddSport";
import RoomsListing from "../Pages/Admin/Hostel/RoomsListing/RoomsListing";
import AddRoom from "../Pages/Admin/Hostel/AddRoom/AddRoom";
import TransportsListing from "../Pages/Admin/Transports/TransportsListing/TransportsListing";
import AddTransport from "../Pages/Admin/Transports/AddTransport/AddTransport";
import HolidaysListing from "../Pages/Admin/Holidays/HolidaysListing/HolidaysListing";
import AddHolidays from "../Pages/Admin/Holidays/AddHolidays/AddHolidays";
import SchoolLibraryListing from "../Pages/Admin/SchoolLibrary/SchoolLibraryListing/SchoolLibraryListing";
import AddBook from "../Pages/Admin/SchoolLibrary/AddBook/AddBook";
import { List, Users } from "react-feather";
import SingleUserResult from "../Pages/Admin/Results/SingleUserResult/SingleUserResult";

export const AdminRoutes = [
  // Admin Routes
  // Dashboard
  {
    id: "admin_dashboard",
    path: "/user/admin/dashboard",
    title: "Admin Dashboard",
    layout: "admin",
    parent: true,
    component: <Dashboard />,
    icon: <List />,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Profile
  {
    id: "admin_profile",
    path: "/user/admin/profile",
    title: "Profile",
    layout: "admin",
    parent: false,
    component: <Profile />,
  },

  // Schools
  {
    id: "admin_schools_listing",
    path: "/user/admin/schools",
    title: "Schools",
    layout: "admin",
    parent: true,
    component: <SchoolsListing />,
    icon: <i className="fas fa-building"></i>,
    activeIcon: (
      <i className="fas fa-building" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_add_school",
    path: "/user/admin/schools/add",
    title: "Add School",
    layout: "admin",
    parent: false,
    component: <AddSchool />,
    icon: <i className="fa-solid fa-gauge"></i>,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_update_school",
    path: "/user/admin/schools/update/*",
    title: "Update",
    layout: "admin",
    parent: false,
    component: <AddSchool />,
    icon: <i className="fa-solid fa-gauge"></i>,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Users
  {
    id: "admin_pending_approval",
    path: "/user/admin/users",
    title: "Users",
    layout: "admin",
    hasChild: true,
    isOPen: true,
    parent: true,
    component: <PendingApproval />,
    icon: <Users size={18} />,
    children: [
      {
        id: "admin_pending_approval",
        path: "/user/admin/pending",
        title: "Pending",
        layout: "admin",
        parent: true,
        component: <PendingApproval />,
      },
      {
        id: "admin_pending_approval",
        path: "/user/admin/rejected",
        title: "Rejected",
        layout: "admin",
        parent: true,
        component: <RejectedApproval />,
      },

      {
        id: "admin_pending_approval",
        path: "/user/admin/approved",
        title: "Approved",
        layout: "admin",
        parent: true,
        component: <ApprovedUsers />,
      },
    ],
  },
  {
    id: "user_profile",
    path: "/user/admin/users/profile/:id",
    title: "User Profile",
    layout: "admin",
    parent: false,
    component: <UserProfile />,
    icon: <Users size={18} />,
  },

  // Classes And Courses
  {
    id: "admin_classes",
    path: "/user/admin/classes",
    title: "Classes And Courses",
    layout: "admin",
    parent: true,
    component: <ClassesAndCourses />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_add_classes",
    path: "/user/admin/classes/add",
    title: "",
    layout: "admin",
    parent: false,
    component: <AddClass />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_update_classes",
    path: "/user/admin/classes/update/*",
    title: "",
    layout: "admin",
    parent: false,
    component: <AddClass />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_courses",
    path: "/user/admin/classes/details/*",
    title: "Courses",
    layout: "admin",
    parent: false,
    component: <CoursesListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_add_courses",
    path: "/user/admin/classes/courses/add/*",
    title: "",
    layout: "admin",
    parent: false,
    component: <AddCourse />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_update_courses",
    path: "/user/admin/classes/courses/update/*",
    title: "",
    layout: "admin",
    parent: false,
    component: <AddCourse />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Attendance
  {
    id: "admin_attendance_courses",
    path: "/user/admin/classes/courses/attendance/:id/:id",
    title: "",
    layout: "admin",
    parent: false,
    component: <Attendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_attendance_courses",
    path: "/user/admin/classes/courses/attendance/add/:id/:id",
    title: "",
    layout: "admin",
    parent: false,
    component: <AddAttendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_attendance_courses",
    path: "/user/admin/classes/courses/attendance/details/",
    title: "",
    layout: "admin",
    parent: false,
    component: <PreviousAttendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Exams
  {
    id: "admin_exams",
    path: "/user/admin/classes/:id/courses/:id/exams",
    title: "Exams",
    layout: "admin",
    parent: false,
    component: <ExamListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_exams",
    path: "/user/admin/classes/:id/courses/:id/exams/add",
    title: "Add Exam",
    layout: "admin",
    parent: false,
    component: <AddExam />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_exams",
    path: "/user/admin/classes/:id/courses/:id/exams/update/:id",
    title: "Update Exam",
    layout: "admin",
    parent: false,
    component: <AddExam />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Results
  {
    id: "admin_result",
    path: "/user/admin/classes/:id/courses/:id/exams/:id/result/add",
    title: "Add Result",
    layout: "admin",
    parent: false,
    component: <AddResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_result_view",
    path: "/user/admin/classes/:id/courses/:id/exams/:id/result/:id",
    title: "View Result",
    layout: "admin",
    parent: false,
    component: <ExamResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_result_view",
    path: "/user/admin/classes/user-result",
    title: "View Result",
    layout: "admin",
    parent: false,
    component: <SingleUserResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Expenses
  {
    id: "admin_expenses",
    path: "/user/admin/expenses",
    title: "Accounts",
    layout: "admin",
    hasChild: true,
    parent: true,
    icon: <i className="fas fa-file-invoice-dollar"></i>,
    children: [
      {
        id: "admin_expenses",
        path: "/user/admin/expenses",
        title: "Expenses",
        layout: "admin",
        parent: true,
        component: <Expenses />,
      },
      {
        id: "admin_income",
        path: "/user/admin/income",
        title: "Income",
        layout: "admin",
        parent: true,
        component: <Income />,
      },
    ],
  },
  {
    id: "admin_income",
    path: "/user/admin/income/add",
    title: "Income",
    layout: "admin",
    parent: false,
    component: <AddIncome />,
  },
  {
    id: "admin_income",
    path: "/user/admin/income/update",
    title: "Income",
    layout: "admin",
    parent: false,
    component: <AddIncome />,
  },
  {
    id: "admin_add_expenses",
    path: "/user/admin/expenses/add",
    title: "Add Expenses",
    layout: "admin",
    parent: false,
    component: <AddExpenses />,
  },
  {
    id: "admin_update_expenses",
    path: "/user/admin/expenses/update",
    title: "Update Expenses",
    layout: "admin",
    parent: false,
    component: <AddExpenses />,
  },

  // Sports
  {
    id: "admin_sports_listing",
    path: "/user/admin/sports",
    title: "Sports",
    layout: "admin",
    parent: true,
    component: <SportsListing />,
    icon: <i className="fas fa-baseball-ball"></i>,
    activeIcon: (
      <i className="fas fa-baseball-ball" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_add_sport",
    path: "/user/admin/sports/add",
    title: "Add Sport",
    layout: "admin",
    parent: false,
    component: <AddSport />,
    icon: <i className="fas fa-baseball-ball"></i>,
    activeIcon: (
      <i className="fas fa-baseball-ball" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_update_sport",
    path: "/user/admin/sports/update/:id",
    title: "Update Sport",
    layout: "admin",
    parent: false,
    component: <AddSport />,
    icon: <i className="fas fa-baseball-ball"></i>,
    activeIcon: (
      <i className="fas fa-baseball-ball" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Hostel
  {
    id: "admin_hostel_listing",
    path: "/user/admin/hostel",
    title: "Hostel",
    layout: "admin",
    parent: true,
    component: <RoomsListing />,
    icon: <i className="fas fa-hotel"></i>,
    activeIcon: <i className="fas fa-hotel" style={{ color: "#ffffff" }}></i>,
  },
  {
    id: "admin_hostel_add",
    path: "/user/admin/hostel/add",
    title: "Add Room",
    layout: "admin",
    parent: false,
    component: <AddRoom />,
    icon: <i className="fas fa-hotel"></i>,
    activeIcon: <i className="fas fa-hotel" style={{ color: "#ffffff" }}></i>,
  },
  {
    id: "admin_hostel_update",
    path: "/user/admin/hostel/update/:id",
    title: "Update Room",
    layout: "admin",
    parent: false,
    component: <AddRoom />,
    icon: <i className="fas fa-hotel"></i>,
    activeIcon: <i className="fas fa-hotel" style={{ color: "#ffffff" }}></i>,
  },

  // Transport
  {
    id: "admin_transports_listing",
    path: "/user/admin/transport",
    title: "Transports",
    layout: "admin",
    parent: true,
    component: <TransportsListing />,
    icon: <i className="fas fa-bus"></i>,
    activeIcon: <i className="fas fa-bus" style={{ color: "#ffffff" }}></i>,
  },
  {
    id: "admin_transport_add",
    path: "/user/admin/transport/add",
    title: "Add Transport",
    layout: "admin",
    parent: false,
    component: <AddTransport />,
    icon: <i className="fas fa-bus"></i>,
    activeIcon: <i className="fas fa-bus" style={{ color: "#ffffff" }}></i>,
  },
  {
    id: "admin_transport_update",
    path: "/user/admin/transport/update/:id",
    title: "Update Transport",
    layout: "admin",
    parent: false,
    component: <AddTransport />,
    icon: <i className="fas fa-bus"></i>,
    activeIcon: <i className="fas fa-bus" style={{ color: "#ffffff" }}></i>,
  },

  // Holidays
  {
    id: "admin_holidays_listing",
    path: "/user/admin/holidays",
    title: "Holidays",
    layout: "admin",
    parent: true,
    component: <HolidaysListing />,
    icon: <i className="fas fa-holly-berry"></i>,
    activeIcon: (
      <i className="fas fa-holly-berry" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_holidays_add",
    path: "/user/admin/holidays/add",
    title: "Add Holidays",
    layout: "admin",
    parent: false,
    component: <AddHolidays />,
    icon: <i className="fas fa-holly-berry"></i>,
    activeIcon: (
      <i className="fas fa-holly-berry" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "admin_holidays_update",
    path: "/user/admin/holidays/update/:id",
    title: "Update Holidays",
    layout: "admin",
    parent: false,
    component: <AddHolidays />,
    icon: <i className="fas fa-holly-berry"></i>,
    activeIcon: (
      <i className="fas fa-holly-berry" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Library
  {
    id: "admin_library_listing",
    path: "/user/admin/library",
    title: "Library",
    layout: "admin",
    parent: true,
    component: <SchoolLibraryListing />,
    icon: <i className="fas fa-book"></i>,
    activeIcon: <i className="fas fa-book" style={{ color: "#ffffff" }}></i>,
  },
  {
    id: "admin_library_add",
    path: "/user/admin/library/add",
    title: "Add Library",
    layout: "admin",
    parent: false,
    component: <AddBook />,
    icon: <i className="fas fa-book"></i>,
    activeIcon: <i className="fas fa-book" style={{ color: "#ffffff" }}></i>,
  },
  {
    id: "admin_library_update",
    path: "/user/admin/library/update/:id",
    title: "Update Library",
    layout: "admin",
    parent: false,
    component: <AddBook />,
    icon: <i className="fas fa-book"></i>,
    activeIcon: <i className="fas fa-book" style={{ color: "#ffffff" }}></i>,
  },
];
